import React from 'react';
import { Form, Input, Select, InputNumber, DatePicker, Switch, Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Option } = Select;
const { TextArea } = Input;

const FormField = ({
  type = 'input',
  name,
  label,
  required = false,
  rules = [],
  options = [],
  placeholder,
  disabled = false,
  className = '',
  error,
  ...props
}) => {
  const getValidationRules = () => {
    const validationRules = [...rules];
    
    if (required) {
      validationRules.unshift({
        required: true,
        message: `${label} is required`,
      });
    }

    return validationRules;
  };

  const renderField = () => {
    const commonProps = {
      placeholder,
      disabled,
      'aria-label': label,
      'aria-required': required,
      'aria-invalid': !!error,
      ...props,
    };

    switch (type) {
      case 'input':
        return <Input {...commonProps} />;
      
      case 'password':
        return <Input.Password {...commonProps} />;
      
      case 'email':
        return <Input type="email" {...commonProps} />;
      
      case 'number':
        return <InputNumber className="w-full" {...commonProps} />;
      
      case 'textarea':
        return <TextArea rows={4} {...commonProps} />;
      
      case 'select':
        return (
          <Select
            {...commonProps}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        );
      
      case 'multiselect':
        return (
          <Select
            mode="multiple"
            {...commonProps}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {options.map((option) => (
              <Option key={option.value} value={option.value}>
                {option.label}
              </Option>
            ))}
          </Select>
        );
      
      case 'date':
        return <DatePicker className="w-full" {...commonProps} />;
      
      case 'daterange':
        return <DatePicker.RangePicker className="w-full" {...commonProps} />;
      
      case 'switch':
        return <Switch {...commonProps} />;
      
      case 'upload':
        return (
          <Upload {...commonProps}>
            <Button icon={<UploadOutlined />}>Upload</Button>
          </Upload>
        );
      
      default:
        return <Input {...commonProps} />;
    }
  };

  return (
    <Form.Item
      name={name}
      label={label}
      rules={getValidationRules()}
      className={className}
      validateStatus={error ? 'error' : ''}
      help={error}
    >
      {renderField()}
    </Form.Item>
  );
};

export default FormField;
